import axios from 'axios';

const baseURL = '/api';
const articlesURL = '/articles';
const approveURL = '/approve';
const unapproveURL = '/unapprove';
const fieldAttributesURL = '/field_attributes';

/**
 * Get articles
 * Hits endpoint: GET /api/articles
 * @param page page number, returns 10 articles per page
 */
export const getArticles = async (page) => {
	const query = page ? `?page=${page}` : '';
	try {
		return await axios.get(`${baseURL}${articlesURL}${query}`);
	} catch (error) {
		console.error(error);
	}
};

export const getArticleByID = async (id) => {
	try {
		return await axios.get(`${baseURL}${articlesURL}/${id}`);
	} catch (error) {
		console.error(error);
	}
};

/**
 * Get the article information
 * Hits endpoint: GET /api/articles?organization_id=:id
 * @param orgID the id for the article to find
 */
export const getArticlesByOrgId = async (orgID) => {
	try {
		return await axios.get(
			`${baseURL}${articlesURL}?organization_id=${orgID}`
		);
	} catch (error) {
		console.error(error);
	}
};

/**
 * Updates the article information given an ID and new articleData
 * Hits endpoint: PUT /api/articles/:id
 * @param articleID the id for the article to update
 * @param articleData the new data to overwrite existing data
 */
export const putArticle = (articleID, articleData) => {
	return axios
		.put(`${baseURL}${articlesURL}/${articleID}`, articleData)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Creates a new contact with the given information
 * Hits endpoint: CREATE /api/articles
 * @param articleData the article information
 */
export const postArticle = (articleData) => {
	return axios
		.post(`${baseURL}${articlesURL}`, articleData)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Deletes a contact with the given articleID
 * Hits endpoint: DELETE /api/articles/:id
 * @param articleID the id of the article we want to delete
 */
export const deleteArticle = (articleID) => {
	return axios
		.delete(`${baseURL}${articlesURL}/${articleID}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Approves article
 * Hits endpoint: POST /api/articles/:article_id/approve
 * @param articleID the id of the article to approve
 */
export const approveArticle = (articleID) => {
	return axios
		.post(`${baseURL}${articlesURL}/${articleID}${approveURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Unapproves article
 * Hits endpoint: POST /api/articles/:article_id/unapprove
 * @param articleID the id of the article to unapprove
 */
export const unapproveArticle = (articleID) => {
	return axios
		.post(`${baseURL}${articlesURL}/${articleID}${unapproveURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};

/**
 * Gets field attributes
 * Hits endpoint: GET /api/articles/field_attributes
 */
export const getFieldAttributes = () => {
	return axios
		.get(`${baseURL}${articlesURL}${fieldAttributesURL}`)
		.then((response) => {
			return response;
		})
		.catch((error) => {
			console.error(error);
		});
};
